import { inject } from "@angular/core";
import type { ResolveFn } from "@angular/router";
import { catchError } from "rxjs";
import { PersonnelService } from "../../presentation/pages/personnel/services/personnel.service";
import { SignalService } from "../services/loader.service";
import { showNotification } from "../utils/toast";

export const personnelResolver: ResolveFn<any> = (route, state) => {
  const personnelService = inject(PersonnelService);
  const signalService = inject(SignalService);
  const resourceId = route.params["resourceId"];
  signalService.loadingSignal.set(true);

  return personnelService.resourcePlanning(resourceId).pipe(
    catchError((err) => {
      signalService.loadingSignal.set(false);
      showNotification(
        "Error while retrieving data for this resource",
        "error",
      );
      throw err;
    }),
  );
};
